import { gql, useMutation } from "@apollo/client";

export const UPDATE_CHANNEL_PORTAL_CONFIG = gql`
    mutation UpdateChannelPortalConfig($channelId: Long!, $allowQueryAbnormalWeighingInfo: Boolean!) {
        updateChannelPortalConfig(channelId: $channelId, allowQueryAbnormalWeighingInfo: $allowQueryAbnormalWeighingInfo)
    }
`;

export interface UpdateChannelPortalConfigVariables {
    channelId: number;
    allowQueryAbnormalWeighingInfo: boolean;
}

export const useUpdateChannelPortalConfig = () => {
    return useMutation<{ updateChannelPortalConfig: boolean }, UpdateChannelPortalConfigVariables>(
        UPDATE_CHANNEL_PORTAL_CONFIG
    );
};
